/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import CurateListComponent from 'app/components/Curate/CurateListComponent.jsx';
import CurateTabs from 'app/components/Curate/CurateTabs.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class CurateItemsView extends React.Component {
    render() {
        let tabs = (
            <CurateTabs
                {...this.props}
                active="curate-items"
                recordPath={this.props.recordPath}/>
        );
        let main = (<CurateListComponent {...this.props}/>);

        return (
            <Content
                {...this.props}
                header={tabs}
                main={main} />
        );

    }

};

CurateItemsView.propTypes = {
    recordPath: PropTypes.func
};

CurateItemsView.defaultProps = {
    recordPath: () => {}
};

export default ComponentWithContext(CurateItemsView);
